// Will fix translations below
export const modes = {
	light: '',
	dark: '',
};

export const userPref = 'app:brand:mode';

// Fix translations since we are loaded in teandem with i18n via css
dispatcher.once('app:i18n:ready', () => {
	modes.dark = i18n.t('i18n.themeModeDark');
	modes.light = i18n.t('i18n.themeModeLight');
});

export default {modes, userPref};
